var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessfulTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 147,
    viewBox: "0 0 161 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 69.1009,
    cy: 78.1336,
    r: 63.8665,
    fill: "#00C14E",
    stroke: "#64DF9E",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3633 59.9945L67.5668 93.198L154.265 6.5",
    stroke: "#00C14E",
    strokeWidth: 12.9125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfulTick);
export default __webpack_public_path__ + "static/media/successfulTick.02f4e0f615c049d0e7aa424ca9b8a8b2.svg";
export { ForwardRef as ReactComponent };